import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { TabsModule, TabsetComponent } from 'ngx-bootstrap/tabs';
import { CommonModule } from '@angular/common';
import { find, findIndex, findKey, forEach, keys, cloneDeep, includes, isNil, some, pullAt, map, concat, get, trim, reduce, startsWith} from 'lodash-es';
import {
  LOGIN_OPTIONS,
  setLandingPageOptions,
  SecurityService,
  SSO_PROVIDERS,
  WHITE_LIST,
  POLICY_OPTIONS,
  getPageObjectInMap,
  AuthorizationService,
  JKS_FILE_PATH,
  KEY_STORE_NAME,
  METADATA_OPTIONS,
  JWS_PROVIDER, OPAQUE_TOKEN_PROVIDER
} from '@wms/settings/security';
import { BaseComponent, WmsToggleComponent, WmsMessageComponent } from '@wms/app/components';
import { ServiceFactoryService, NotificationService, DialogService } from '@wms/services';
import { BaseVariableService, VARIABLE_CONSTANTS } from '@wms/variables';
import {getClonedObject, sort, replace, isValidJavaPackageName, isString} from '@wms/core';
import { RouterModule, Router } from '@angular/router';
import { IWMSSettingsSubWorkspace } from '@wms/settings'
import { AD_PROVIDER, CAS_PROVIDER, CUSTOM_PROVIDER, DB_PROVIDER, DEMO_PROVIDER, LDAP_PROVIDER, OPENID_PROVIDER, SAML_PROVIDER } from '@wms/settings/security';
import { propFactory as PropertiesFactory } from '@wm/components-base';
import { PageWsService } from '@wms/workspace';
import { isValidWebURL, noop, isValidXFrameUrls, stringStartsWith } from '@wm/core';
import { WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent } from "@wms/components";

@Component({
  standalone: true,
  selector: 'wms-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.less'],
  imports: [TabsModule, CommonModule, RouterModule, WmsToggleComponent, WmsMessageComponent, WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent]
})
export class SecurityComponent extends BaseComponent implements IWMSSettingsSubWorkspace, OnInit {
  dialogService: DialogService;
  securityService: SecurityService;
  authorizationService: AuthorizationService;
  variableService: BaseVariableService;
  pageWsService: PageWsService;
  notificationService: NotificationService;
  initialSecurityVal: boolean;
  isInitialLoad: boolean = true;
  showNoProviderSaved: boolean = false;
  isProviderAllowedToDisable: boolean = false;
  @ViewChild('tabset') tabset: TabsetComponent;
  static ROLE_MAPPING_DATABASE : string = 'ROLE_MAPPING_DATABASE';
  static ROLE_MAPPING_LDAP : string = 'ROLE_MAPPING_LDAP';
  static ROLE_MAPPING_AD : string = 'ROLE_MAPPING_AD';
  static ROLE_MAPPING_ATTR_NAME : string = 'ROLE_MAPPING_ATTR_NAME';

  constructor(private router: Router) {
    super();
    this.securityService = inject(SecurityService);
    this.serviceFactory = inject(ServiceFactoryService);
    this.authorizationService = inject(AuthorizationService);
    this.variableService = inject(BaseVariableService);
    this.pageWsService = inject(PageWsService);
    this.notificationService = inject(NotificationService);
    this.dialogService = inject(DialogService);
    this.processStudioRefreshQueue();
  }
  isProvidersDisabled: boolean = false;
  tabGroups = [{
    name: 'General',
    tabId: 'general',
    isActive: false
  }, {
    name: 'Authentication & Authorization',
    tabId: 'Auth',
    isActive: false
  }];
  XSRF_HEADER_NAME = 'X-WM-XSRF-TOKEN';
  XSRF_COOKIE_NAME = 'wm_xsrf_token';
  LOGIN_VARIABLE_NAME = 'loginAction';
  LOGOUT_VARIABLE_NAME = 'logoutAction';
  LOGGED_IN_USER_VARIABLE_NAME = 'loggedInUser';
  generalOptions: any;
  authInfo: any;
  xssConfig: any;
  serviceFactory: ServiceFactoryService;
  localeMap = {
    'providerId': 'LABEL_PROVIDER_ID',
    'authorizationUrl': 'LABEL_AUTHORIZATION_URL',
    'tokenUrl': 'LABEL_TOKEN_URL',
    'jwkSetUrl': 'LABEL_JWKS_URL',
    'userInfoUrl': 'LABEL_USER_INFO_ENDPOINT',
    'clientId': 'LABEL_CLIENT_ID',
    'clientSecret': 'LABEL_CLIENT_SECRET',
    'incorrectProviderId': 'LABEL_INCORRECT_PROVIDER_ID'
  };
  //variable to hold editor different tabs
  securityTabs: any = [
    {
      id: 'ssl',
      title: 'LABEL_SSL_ENABLE',
      tooltip: 'LABEL_SSL_ENABLE_TOOLTIP',
      imgClass: 'wms wms-gear',
      showTab: 'general',
      isDefault: true
    },
    {
      id: 'safeguards',
      title: 'LABEL_OWASP_TOOLTIP',
      tooltip: 'LABEL_OWASP',
      imgClass: 'wms wms-gear',
      showTab: 'general'
    },
    {
      id: 'truststore',
      title: 'LABEL_TRUSTSTORE',
      tooltip: 'LABEL_TRUSTSTORE',
      imgClass: 'wms wms-gear',
      showTab: 'general'
    },
    {
      'title': 'LABEL_AUTHENTICATION',
      'showTab': 'Auth',
      'subTabs': [
        {
          showTab: 'auth',
          id: 'provider',
          title: 'LABEL_USER_CONFIGURATION',
          tooltip: 'LABEL_USER_CONFIGURATION_TOOLTIP',
          imgClass: 'wms wms-gear',
          isDefault: true
        },
        {
          showTab: 'auth',
          id: 'roleconfig',
          title: 'LABEL_LOGIN_CONFIGURATION',
          tooltip: 'LABEL_LOGIN_CONFIGURATION_TOOLTIP',
          imgClass: 'login-config',
        },
        {
          showTab: 'auth',
          id: 'csrf',
          title: 'LABEL_CSRF',
          tooltip: 'LABEL_CSRF_TOOLTIP',
          imgClass: 'login-config',
        }
      ]
    },
    {
      'title': 'LABEL_AUTHORIZATION',
      'showTab': 'Auth',
      'subTabs': [
        {
          showTab: 'auth',
          id: 'roles',
          title: 'LABEL_ROLES',
          tooltip: 'LABEL_ROLES_TOOLTIP',
          imgClass: 'roles',
        },
        {
          showTab: 'auth',
          id: 'web',
          title: 'LABEL_PAGES',
          tooltip: 'LABEL_PAGES_TOOLTIP',
          imgClass: 'permission',
          parentId: 'permissions'
        },
        {
          showTab: 'auth',
          id: 'services',
          title: 'LABEL_SERVICES',
          tooltip: 'LABEL_SERVICESTOOLTIP',
          imgClass: 'permission',
          parentId: 'permissions'
        },
        {
          showTab: 'auth',
          id: 'prefabs',
          title: 'LABEL_PREFABS',
          tooltip: 'LABEL_PREFABS_TOOLTIP',
          imgClass: 'permission',
          parentId: 'permissions'
        }
      ]
    }
  ];
  dialogCaption: string = 'Delete Provider';
  dialogContent: string = '';
  deleteProviderIndex: number;
  security: any;
  securityProps: any;
  tabGroup: any;
  selectedTab: any = {};
  saveInProgress: boolean = false;
  authProviders: any[] = [];
  isNewSecurityProvider: boolean = false;
  ngOnInit(): void {
    this.securityService.showMessage(this.locale.MESSAGE_ENABLE_SECURITY, 'warning')
    this.security = this.securityService.security;
    this.securityProps = this.securityService.securityProps;
    //Always get the pages list, as there might be new pages added or deleted
    this.authorizationService.getPagesListForPermissions();
    if (!this.security.prefabs || !this.security.prefabs.length) {
      this.authorizationService.getPrefabsListForPermissions();
    }
    this.security.sessionPersistenceOptions = [
      { key: 'IN_MEMORY', value: this.locale.LABEL_SESSION_PERSISTENCE_IN_MEMORY },
      { key: 'REDIS', value: 'REDIS' },
      { key: 'JDBC', value: 'JDBC' },
      { key: 'MONGODB', value: 'MONGODB' }
    ];
    this.security.policyType = POLICY_OPTIONS.IMPORT;
    (this.projectService.getPagesList() as Promise<any>).then(() => {
      this.security.pagesList = this.projectService.getPageNames('PAGE');
      if (!this.security.landingPagesList) {
        setLandingPageOptions(this.security);
      }
    });
    this.security.cookieName = this.XSRF_COOKIE_NAME;
    this.security.queryType = this.securityService.QUERY_TYPES.HQL;
    this.security.providerOptions = [
        DEMO_PROVIDER,
        DB_PROVIDER,
        LDAP_PROVIDER,
        AD_PROVIDER,
        CAS_PROVIDER,
        SAML_PROVIDER,
        OPENID_PROVIDER,
        CUSTOM_PROVIDER,
        JWS_PROVIDER,
        OPAQUE_TOKEN_PROVIDER
      ];
    this.security.roleConfig = 'BASIC';
    delete this.security.sqlQueryRoles;
    this.securityService.databaseFormInititalValue = {
    Database : {},
    LDAP: {},
    AD : {},
    CAS : {},
    SAML : {},
    OpenId : {}
  };
    this.security.userName = null

    if (!this.variableService.studioCopy['App']) {
      this.variableService.studioCopy['App'] = {};
      this.variableService.initAppVariables();
    }
    (this.serviceFactory.getServicesWithType() as Promise<any>).then(() => {
      this.security.dataModels = sort(this.serviceFactory.databaseNames);
    });
    this.getRolesConfig();
    this.security.metadataSrcOptionsMap = reduce(METADATA_OPTIONS, (result: any, option) => {
      result[option.label] = option.value;
      return result;
    }, {});
    this.getGeneralOptions();

    $('tabset ul').on('click', () =>{
      this.confirmTabSwitch()
    })

  }

  private getGeneralOptions(reloadFlag?: any) {
    (this.securityService.getGeneralOptions(reloadFlag) as Promise<any>).then((options: any) => {
      this.generalOptions = options;
      if (typeof options === 'object') {
        let xssConfig = options.xssConfig;
        this.securityService.xssConfig = xssConfig;
        this.securityService.isXssConfigSet = true;
        this.initxFrameOptions(options.frameOptions);
        this.initCorsConfig(options.corsConfig);
        this.initCustomFilterList(options.customFilterList);
        this.security.allowedHosts = options.allowedHosts;
        this.security.sslPort = options.sslConfig.sslPort;
        this.security.prevSSLPort = this.security.sslPort;
        this.initCspConfig(options.cspConfig);
        this.initTrustStoreConfig(options.trustStoreConfig);
        this.initMtlsConfig(options.mtlsConfig);
        this.initClientSSLHostNameVerificationEnabled(options.clientSSLHostNameVerificationEnabled);
        this.securityService.initXSSConfig(this.securityService.xssConfig);
      }
      this.navigateToSubtabs();
    }).catch((e: any) => {
      this.navigateToSubtabs();
    });
  }

  private getRolesConfig(reloadFlag?: any) {
    (this.securityService.getRolesConfig(reloadFlag) as Promise<any>).then((roles) => {
      this.security.roles = [];
      if (Array.isArray(roles)) {
        roles.map((role) => {
          role.roleConfig.landingPage = role.roleConfig.landingPage === null ? 'Main' : role.roleConfig.landingPage;
          this.security.roles.push(role.name);
          return role;
        });
        this.security.roles
        this.initPermissions();
        this.security.roleConfigurations = roles;
      }
    });
  }

  override refreshStudio(changeSet: any): boolean {
    let isAuth = this.isAuthSettings(changeSet);
    let isRefreshDone = false;
    if(isAuth) {
      isRefreshDone = true;
      setTimeout(() => {
        //$TODO: optimize this later. check the file changes and just call required api
        this.setConfigFromAuthInfo(true);
        this.getRolesConfig(true);
        this.getGeneralOptions(true);
      }, 0);
    }
    return isRefreshDone;
  }

  isAuthSettings(changeSet: any) {
    let listOfChangesObj = changeSet?.mergedFiles;
    let isAuth = false;
    if(listOfChangesObj) {
      for (const fileName in listOfChangesObj) {
        if(fileName.indexOf("auth-info.json") || fileName.indexOf("roles.json") !== -1 || fileName.indexOf("general-options.json") !== -1) {
          isAuth = true;
          return isAuth;
        }
      }
    }
    return isAuth;
  }

  addNewSecurityProvider() {
    if(this.isNewSecurityProvider) {
      setTimeout(()=> {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_SAVE_CURRENT_PROVIDER'], 'info');
      });
    }
    else {
      this.showNoProviderSaved = false;
      this.isNewSecurityProvider = true;
      this.security.provider = '';
      this.switchSecurityTabs(this.securityTabs[3].subTabs[0], this.securityTabs[3])
    }
    setTimeout(()=> {
      this.isProviderAllowedToDisable = this.isAllowedToDisableSecurityProvider();
    });
  }
  //switch to provider under the Security Provider
  switchToProvider(tab: any, parent?: any) {
    this.setTabActive(tab, parent)
    this.security.provider = this.security.providerOptions.find((option: any) => {
      if (stringStartsWith(tab.id, "OPENID") ||stringStartsWith(tab.id, "JWS")) {
        let providerId: string = tab.id.split("(")[0], selectedModel: string = tab.id.split("(")[1].substring(0, tab.id.split("(")[1].length - 1);
        this.securityService.isOpenIdProviderDisabled = true;
        setTimeout(()=> {
          if(stringStartsWith(tab.id, "OPENID") ){
            this.securityService.openId._selectModel = selectedModel;
            this.securityService.notifyUpdateOpenIdProviderId(selectedModel)
          }
          if(stringStartsWith(tab.id, "JWS") ){
            this.securityService.selectedJswProviderName = selectedModel
            this.securityService.notifyUpdateJwsProviderId(selectedModel)
          }
        },200);
        if (providerId === option.id) return true;
      }
      else if (option.id === tab.id) {
        return true;
      }
      return false;
    });
    this.isProvidersDisabled = true;
    this.isNewSecurityProvider = false;
    this.isProviderAllowedToDisable = this.isAllowedToDisableSecurityProvider()
    this.router.navigate(['/settings/security/' + parent.showTab + '/' + parent.id]);
  }
  //delete the security provider
  deleteSecurityProvider(index: number) {
    this.authInfo.authProviders.splice(index, 1);
    this.securityService.setAuthInfo({
      config: this.authInfo
    }).then(() => {
      this.generateAuthProviders()
      let availableProviderIndex: number = this.getIndexOfAvailableProvider();
      if (this.authProviders.length > 0 && availableProviderIndex !== -1) {
        this.switchToProvider(this.authProviders[availableProviderIndex], this.securityTabs[3].subTabs[0]);
      }
      else {
        this.switchSecurityTabs(this.securityTabs[3].subTabs[0], this.securityTabs[3]);
      }
    }).catch((errObj) => {
      const err = get(errObj, 'error.errors.error[0]')
      this.securityService.showMessage(replace(err.message.replaceAll('{', '${'), err.parameters) || errObj, 'error');
    });

  }
  // generates the authProvider from the authProviders available in authInfo
  generateAuthProviders() {
    let authProviders: any = this.authInfo.authProviders;
    let providers: any[] = [];
    forEach(authProviders, (provider) => {
      providers.push({
        showTab: 'auth',
        id: (provider.type === 'OPENID' || provider.type === 'JWS'  )  ? provider.type + '(' + provider.providerId + ')' : provider.type,
        parentId: 'provider'
      });
    })
    this.authProviders = providers;
    this.showNoProviderSaved = this.getIndexOfAvailableProvider() === -1;
  }

  getProviderName(name: string) {
    if(name==='OPAQUE_TOKEN'){
      name ='OPAQUE';
    }
    return name.replace(/\(([^)]+)\)/, ' ($1) ');
  }

  navigateToSubtabs() {
    this.setConfigFromAuthInfo();
    this.setPlaceholders(this.security);
    const locationParams = window.location.pathname.split('/');
    if (locationParams.length === 4) {
      this.isInitialLoad = true
      this.switchSecurityTabs(this.securityTabs[0]);
      this.tabGroup = this.tabGroups[0];
      this.tabGroup.isActive = true;
    } else {
      let securityTab: any;
      let parentTab: any;
      forEach(this.securityTabs, (tab): any => {
        if (tab.id === locationParams[5]) {
          securityTab = tab
          return false;
        } else if (tab.subTabs) {
          forEach(tab.subTabs, (subTab): any => {
            if (subTab.id === locationParams[5]) {
              securityTab = subTab;
              parentTab = tab;
              return false;
            }
          });
        }
      });
      const tabGroupIndex = findIndex(this.tabGroups, (tab: any) => tab.tabId.toLowerCase() === locationParams[4]);
      this.switchSecurityTabs(securityTab, parentTab);
      this.tabGroup = this.tabGroups[tabGroupIndex];
      this.tabGroup.isActive = true;
    }
  }

  setPlaceholders(security: any) {
    security.placeholder = {};
    //ldap
    security.placeholder.LDAP_url = 'eg: ldap://mydomain.com:389/';
    security.placeholder.LDAP_userSearchPattern = 'eg: uid={0},ou=users,dc=example,dc=com';
    security.placeholder.LDAP_groupSearchBase = 'eg: ou=groups,dc=example,dc=com';
    //ad
    security.placeholder.AD_domain = 'eg: mydomain.com';
    security.placeholder.AD_rootDn = 'eg: dc=mydomain,dc=com';
    security.placeholder.AD_url = 'eg: ldap://ad.mydomain.com';
    //cas
    security.placeholder.CAS_url = 'https://mydomain.com:8080/cas';
    security.placeholder.CAS_loginUrl = 'https://mydomain.com:8080/cas/login';
    security.placeholder.CAS_logoutUrl = 'https://mydomain.com:8080/cas/logout';
    security.placeholder.CAS_validationUrl = 'https://mydomain.com:8080/cas/serviceValidate';
    //saml
    security.placeholder.SAML_metadata = 'Metadata URL (Eg: https://idp-metadata-url/)';
  }

  //set X Frame Options
  initxFrameOptions(xFrameConfig: any) {
    this.security.xFrameMode = xFrameConfig.mode;
    this.security.xFrameAllowFromUrl = xFrameConfig.allowFromUrl;
    this.security.xFrameEnabled = xFrameConfig.enabled;
  }

  //set Cors Options
  initCorsConfig(corsConfig: any) {
    this.security.corsConfig = getClonedObject(corsConfig);
  }

  //set Custom filter list
  initCustomFilterList(customFilterList: any) {
    this.security.customFilterList = getClonedObject(customFilterList);
  }

  fetchProviderOptions() {
    switch (this.security.provider.value) {
      case 'Demo':
        this.securityService.getDemoOptions(this.authInfo);
        break;
      case 'LDAP':
        this.securityService.getLDAPOptions(this.authInfo);
        break;
      case 'Database':
        this.securityService.getDatabaseOptions(this.authInfo);
        break;
      case 'AD':
        this.securityService.getActiveDirectoryOptions(this.authInfo);
        break;
      case 'CAS':
        this.securityService.getCASOptions(this.authInfo);
        break;
      case 'JWS':
        this.securityService.getJWSOptions(this.authInfo);
        break;
      case 'OPAQUE_TOKEN':
        this.securityService.getOpaqueOptions(this.authInfo);
        break;
      case 'SAML':
        this.securityService.getSAMLOptions(this.authInfo);
        break;
      case 'OpenId':
        this.securityService.getOpenIdOptions(this.authInfo);
        break;
      case 'Custom':
        this, this.securityService.getCustomOptions(this.authInfo);
        break;
    }
  }

  setConfigFromAuthInfo(reloadFlag?: any) {
    (this.securityService.getAuthInfo(reloadFlag) as Promise<any>).then((authInfo) => {
      this.authInfo = authInfo;
      this.security.enableSecurity = authInfo.enforceSecurity;
      this.initialSecurityVal = cloneDeep(this.security.enableSecurity);
      if (authInfo.authProviders.length === 0) {
     //   this.security.provider = this.security.providerOptions[0];
        this.security.login.pageName = 'Login';
      }
      (this.securityService.getDefaultProviders() as Promise<any>).then(defaultProvider => {
        this.security.defaultProviderGoogle = defaultProvider[0];
      })
      this.generateAuthProviders();
      if(this.authProviders.length > 0) {
        this.security.provider = find(this.security.providerOptions, { id:
            this.authProviders[0].id.includes("OPENID") ? "OPENID" : this.authProviders[0].id.includes("JWS") ?
              "JWS": this.authProviders[0].id })

      }
      this.fetchProviderOptions();
      this.initBasicConfig(this.generalOptions, authInfo);
      this.security.login = authInfo.loginConfig;
      this.initLoginConfig(authInfo.loginConfig);
      this.initTokenAuthConfig(authInfo.tokenAuthConfig);

      var csrfConfig = authInfo.csrfConfig;
      if (csrfConfig) {
        this.initCSRFConfig(csrfConfig);
      }
      this.initSessionPersistenceConfig(authInfo.sessionPersistenceConfig);
      let availableProviderIndex: number = this.getIndexOfAvailableProvider();
      setTimeout(() => {
        if(this.securityTabs[3].isActive && this.securityTabs[3].subTabs[0].isActive && availableProviderIndex !== -1) {
          this.switchToProvider(this.authProviders[availableProviderIndex], this.securityTabs[3].subTabs[0]);
        }
      },0);
      // TODO
      // this.$broadcast('wms:init-policy-config', this.xssConfig);
    }).catch(() => {
      // TODO?
      // hideSpinner()
    })
  }
 // sets the provider for the select options in security-provider.components  based on provider that is not being used.(i.e, not available in the authProviders)
  setAvailableProviders() {
    let isAvailable: boolean = false;
    for (let provider of this.security.providerOptions) {
      if (this.authInfo && this.authInfo.authProviders && !find(this.authInfo.authProviders, { type: provider.id })) {
        this.security.provider = provider;
        if (provider.id === 'DEMO' && !includes(this.security.dirtyCheckList, 'demoProvider') && !this.isProvidersDisabled && !this.showNoProviderSaved) {
          this.security.dirtyCheckList.push('demoProvider');
        }
        isAvailable = true;
        break;
      }
    }
    if (!isAvailable) {
      this.security.provider = this.security.providerOptions[6];
      this.securityService.openId._selectModel = 'custom';
      this.securityService.notifyUpdateOpenIdProviderId('custom');
    }
  }
  //set csrf config
  initCSRFConfig(csrfConfig: any) {
    this.security.enforceCsrfSecurity = csrfConfig.enforceCsrfSecurity;
    this.security.headerName = csrfConfig.headerName || this.XSRF_HEADER_NAME;
  }

  initBasicConfig(options: any, authInfo: any) {
    this.security.enableSecurity = authInfo.enforceSecurity;
    this.security.useSSL = options.sslConfig.useSSL;
    this.security.excludedUrls = options.sslConfig.excludedUrls;
    this.securityProps.prevProvider = this.security.provider.id;
  }

  //set Session Persistence Config
  initSessionPersistenceConfig(sessionPersistenceConfig: any) {
    this.security.sessionPersistenceConfig.enabledType = sessionPersistenceConfig.enabledType;
    if (sessionPersistenceConfig.config) {
      this.security.sessionPersistenceConfig.config = sessionPersistenceConfig.config;
    }
  }

  //set Token Auth config
  initTokenAuthConfig(tokenAuthConfig: any) {
    this.security.enableTokenAuthSecurity = tokenAuthConfig.enabled === true ? 'ON' : 'OFF';
    this.security.tokenValidityMinutes = tokenAuthConfig.tokenValiditySeconds / 60;
    this.security.tokenAuthParameter = tokenAuthConfig.parameter;
  }

  //set login config
  initLoginConfig(loginOptions: any) {
    if (!loginOptions) {
      return;
    }
    let login = this.security.login;
    login.type = loginOptions.type;
    login.pageName = loginOptions.pageName;
    login.cookieMaxAge = loginOptions.cookieMaxAge ? loginOptions.cookieMaxAge : -1;
    login.cookiePath = loginOptions.cookiePath;
    login.cookieBase64Encode = loginOptions.cookieBase64Encode;
    login.jvmRoute = loginOptions.jvmRoute;
    login.sameSite = loginOptions.sameSite;
    login.sessionConcurrencyConfig = loginOptions.sessionConcurrencyConfig ? loginOptions.sessionConcurrencyConfig : { 'maxSessionsAllowed': -1 };
    login.sessionTimeout.type = loginOptions.sessionTimeout.type;
    login.sessionTimeout.pageName = loginOptions.sessionTimeout.pageName;
    login.sessionTimeout.timeoutValue = loginOptions.sessionTimeout.timeoutValue;

    if (this.projectService.isMobileApplicationType() || this.projectService.isNativeMobileApplicationType()) {
      login.type = LOGIN_OPTIONS.PAGE;
      login.sessionTimeout.type = LOGIN_OPTIONS.PAGE;
      login.sessionTimeout.pageName = login.sessionTimeout.pageName || login.pageName;
    }
    setLandingPageOptions(this.security);
  }

  async confirmTabSwitch() {
    this.securityService.hideMessage(true);
    const isValidSecurityProvider = await this.validateSecurityProvider()

    if (this.isWSDirty() && (!this.validateSecurity() || !isValidSecurityProvider ) ) {
      for (const [index,tab] of this.tabset.tabs.entries()) {
        if(tab.active){
          tab.active = false
          if(index === 0){
            this.tabset.tabs[1].active = true
          }else{
            this.tabset.tabs[0].active = true
          }
          break
        }
      }
      return
    }else{
      for (const [index,tab] of this.tabset.tabs.entries()) {
        if(tab.active){
          this.onTabSelect(this.tabGroups[index])
        }
      }
    }
  }

  onTabSelect(tabGroup: any) {
    this.securityService.hideMessage(true);
    if (tabGroup.isActive) {
      return;
    }
    this.tabGroup.isActive = false;

    this.tabGroup = tabGroup;
    this.tabGroup.isActive = true;
    let selectedTab, groupTab;
    forEach(this.securityTabs, (tab: any): any => {
      if (tab.showTab === this.tabGroup.tabId) {
        if (tab.id && tab.isDefault) {
          selectedTab = tab;
          return false;
        }
        selectedTab = find(tab.subTabs, (subTab) => {
          return subTab.isDefault;
        });
        if (selectedTab) {
          groupTab = tab;
          return false
        }
      }
    });
    this.switchSecurityTabs(selectedTab, groupTab);
  }

  //on switching between tabs
  async switchSecurityTabs(tab: any, parentTab?: any, selectedItem?: any) {
    this.securityService.hideMessage(true);
    if(!this.isInitialLoad){
      const isValidSecurityProvider = await this.validateSecurityProvider()
      if(this.isWSDirty() && (!this.validateSecurity() || !isValidSecurityProvider)) return
   }

    this.isInitialLoad = false
    forEach(this.securityTabs, (tab: any) => {
      if (tab.isActive) {
        tab.isActive = false;
      }
      forEach(tab.subTabs, (subTab: any): any => {
        if (subTab.isActive) {
          subTab.isActive = false;
          return false;
        }
      })
    });
    if (selectedItem) {
      selectedItem.isActive = true;
    }
    this.setTabActive(tab, parentTab);
    if(tab.id === 'provider') {
      //this.setAvailableProviders();
      this.isProvidersDisabled = false;
      let availableProviderIndex: number = this.getIndexOfAvailableProvider();
      if(!this.isNewSecurityProvider && availableProviderIndex !== -1) this.switchToProvider(this.authProviders[availableProviderIndex],this.securityTabs[3].subTabs[0]);
    }
    else {
      if(this.security.provider === '' || this.isNewSecurityProvider) {
        let availableProviderIndex: number = this.getIndexOfAvailableProvider();
        if(availableProviderIndex !== -1) {
          this.security.provider = find(this.security.providerOptions, { id: includes(this.authProviders[availableProviderIndex].id, 'OPENID') ?
              'OPENID' : includes(this.authProviders[availableProviderIndex].id, 'JWS')? 'JWS' : this.authProviders[availableProviderIndex].id });
        }
      }
      this.isNewSecurityProvider = false;
    }
    this.router.navigate(['/settings/security/' + tab.showTab + '/' + tab.id]);
  }

  async validateSecurityProvider(){
    const selectedProvider = 'Demo';
    this.security.isRolesQueryTested = true
   try {
    await this.setProviderConfig(selectedProvider);
    return true
    } catch (error) {
      return false
    }
  }

  setTabActive(tab: any, parentTab: any) {
    if (this.selectedTab) {
      this.selectedTab.isActive = false;
    }
    if (tab && tab.parentId && !tab.isActive) {
      this.initPermissions();
      parentTab.isActive = true;
      // TODO
      // $rs.$emit('wms:switchPermissions', tab.id);
    }
    if (parentTab) {
      parentTab.isActive = true;
    }

    tab.isActive = true;
    this.selectedTab = tab;
  }

  //concatenate all the permissions with the roles
  initPermissions() {
    this.security.permissions = [].concat(this.security.roles);
  }

  onSecurityToggle(enabled: boolean) {
    this.security.enableSecurity = enabled;
    if (this.initialSecurityVal === enabled) {
      this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('permissions', 1));
      this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('roles', 1));
    } else {
      this.security.dirtyCheckList.push('permissions');
      this.security.dirtyCheckList.push('roles');
    }
    if (enabled) {
      this.securityService.hideMessage(true)
    } else {
      this.securityService.showMessage(this.locale.MESSAGE_ENABLE_SECURITY, 'warning')
    }
  }

  //Validates login/session timeout configuration
  isInValidConfig(config: any) {
    if (!config.type) {
      return true;
    }
    if (!this.securityService.isSSO(this.authInfo)) {
      switch (config.type) {
        case LOGIN_OPTIONS.PAGE:
          if (!config.pageName) {
            return true;
          }
          break;
        case LOGIN_OPTIONS.SSO:
          return true;
      }
    }
    return false;
  }

  setPagePermissionAsEveryOne(pageName: any) {
    let pageObject = getPageObjectInMap(pageName, this.security.pages);
    pageObject.permission = [this.locale.LABEL_EVERYONE];
    pageObject.userChanged = true;
  }

  //set cspConfig
  initCspConfig(cspConfig: any) {
    this.security.cspConfig = getClonedObject(cspConfig)
  }

  //set trustStoreConfig
  initTrustStoreConfig(trustStoreConfig: any) {
    if(!trustStoreConfig){
      this.security.trustStoreConfig = {
        "trustStoreConfigType": "",
        "file": "",
        "fileType": "",
        "password": ""
      }
    }else{
      this.security.trustStoreConfig = getClonedObject(trustStoreConfig);
    }
  }

  //set mtlsConfig
  initMtlsConfig(mtlsConfig: any) {
    if(!mtlsConfig){
      this.security.mtlsConfig = {
        "enabled": "false",
        "file": "",
        "fileType": "",
        "password": ""
      }
    }else{
      this.security.mtlsConfig = getClonedObject(mtlsConfig);
    }
  }

  //set clientSSLHostNameVerificationEnabled
  initClientSSLHostNameVerificationEnabled(clientSSLHostNameVerificationEnabled: any) {
    this.security.clientSSLHostNameVerificationEnabled = getClonedObject(clientSSLHostNameVerificationEnabled);
  }

  //save the security settings base on the security provider
  saveChanges() {
    this.securityService.hideMessage(true);
    return new Promise((res, rej) => {
      let
        error = false,
        generalOptions: any,
        promiseList = [];

      if(!this.validateSecurity()) return
      // if(this.security.provider === '') {
      //   this.securityService.hideMessage(false);
      //   this.securityService.showMessage('Please select a security provider', 'loading')
      // }
      this.securityProps.prevProvider = this.security.provider.id;

      if (!this.saveInProgress) {
        this.saveInProgress = true;
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_SAVE_SECURITY'], 'loading')

        if (this.security.enableSecurity) {
          //choosing an authenticated page as login page makes it as unauthenticated.
          if (this.security.login.pageName) {
            this.setPagePermissionAsEveryOne(this.security.login.pageName);
          }
          if (this.security.login.sessionTimeout.pageName) {
            this.setPagePermissionAsEveryOne(this.security.login.sessionTimeout.pageName);
          }
        }

        const truststoreType = this.security.trustStoreConfig.trustStoreConfigType
        this.security.trustStoreConfig.fileType = truststoreType === 'APPLICATION_ONLY' || truststoreType === 'APPLICATION_AND_SYSTEM' ? this.security.trustStoreConfig.fileType : '';
        this.security.trustStoreConfig.password = truststoreType === 'APPLICATION_ONLY' || truststoreType === 'APPLICATION_AND_SYSTEM' ? this.security.trustStoreConfig.password : '';
        this.security.trustStoreConfig.file = truststoreType === 'APPLICATION_ONLY' || truststoreType === 'APPLICATION_AND_SYSTEM' ? this.security.trustStoreConfig.file : '';

        this.security.mtlsConfig.fileType = this.security.mtlsConfig.enabled ? this.security.mtlsConfig.fileType : '';
        this.security.mtlsConfig.password = this.security.mtlsConfig.enabled ? this.security.mtlsConfig.password : '';
        this.security.mtlsConfig.file =  this.security.mtlsConfig.enabled ? this.security.mtlsConfig.file : '';

        generalOptions = {
          'sslConfig': {
            'sslPort': this.security.sslPort,
            'useSSL': this.security.useSSL,
            'excludedUrls': this.security.excludedUrls
          },
          'xssConfig': {
            'enforceXssSecurity': this.security.xssFilterStrategy !== 'NONE',
            'xssFilterStrategy': this.security.xssFilterStrategy.replace(' ', '_'),
            'policyType': this.security.policyType,
            'policyFile': this.security.policyFile,
            'xssSanitizationLayer': this.security.xssSanitizationLayer
          },
          frameOptions: {
            'mode': this.security.xFrameMode,
            'allowFromUrl': this.security.xFrameAllowFromUrl,
            'enabled': this.security.xFrameEnabled
          },
          corsConfig: this.security.corsConfig,
          customFilterList: this.security.customFilterList,
          allowedHosts: this.security.allowedHosts,
          cspConfig: this.security.cspConfig,
          trustStoreConfig: this.security.trustStoreConfig,
          mtlsConfig: this.security.mtlsConfig,
          clientSSLHostNameVerificationEnabled: this.security.clientSSLHostNameVerificationEnabled
        };
        this.authInfo.enforceSecurity = this.security.enableSecurity;
        //When security is disabled sending only the generalOptions
        if (includes(this.security.dirtyCheckList, 'general')) {
          promiseList.push(this.securityService.setGeneralOptions({
            config: generalOptions
          }));
        }

        switch (this.security.provider.id) {
          case 'DEMO':
          case 'LDAP':
          case 'AD':
            generalOptions.sslPort = '8443';
            break;
        }

        this.authInfo.loginConfig = {
          'type': this.security.login.type,
          'pageName': this.security.login.pageName,
          'cookieMaxAge': this.security.login.cookieMaxAge,
          'cookiePath': this.security.login.cookiePath,
          'cookieBase64Encode': this.security.login.cookieBase64Encode,
          'jvmRoute': this.security.login.jvmRoute,
          'sameSite': this.security.login.sameSite,
          'sessionConcurrencyConfig': {
            'maxSessionsAllowed': this.security.login.sessionConcurrencyConfig ? this.security.login.sessionConcurrencyConfig.maxSessionsAllowed : -1
          },
          'sessionTimeout': {
            'type': this.security.login.sessionTimeout.type,
            'pageName': this.security.login.sessionTimeout.pageName,
            'timeoutValue': this.security.login.sessionTimeout.timeoutValue
          }
        };
        this.authInfo.csrfConfig = {
          'enforceCsrfSecurity': this.security.enforceCsrfSecurity,
          'headerName': this.security.headerName,
          'cookieName': this.security.cookieName
        };

        this.authInfo.sessionPersistenceConfig['enabledType'] = this.security.sessionPersistenceConfig.enabledType;
        this.authInfo.sessionPersistenceConfig['config'] = this.authInfo.sessionPersistenceConfig['config'] || this.security.sessionPersistenceConfig.config;
        this.authInfo.sessionPersistenceConfig['config'][this.security.sessionPersistenceConfig.enabledType] = this.security.sessionPersistenceConfig['config'][this.security.sessionPersistenceConfig.enabledType]


        if (this.authInfo.enforceSecurity) {
          // save provider related changes in order to show validation errors first.
          if(!isString(this.security.provider)) {
            promiseList.push(new Promise((resolve, reject) => {
              this.setProviderConfig(this.security.provider.value).then((config: any) => {
                this.setProviderAuthInfo(config.type, config).then((result: any) => {
                  resolve(this.onConfigSet(result));
                }).catch(() => reject())
              }).catch(() => reject());
            }));
          }
          if (this.securityService.hideMsg) {
          // when permissions related tabs are changed
          if (includes(this.security.dirtyCheckList, 'permissions')) {
            let $permission = new Promise((resolve, reject) => {
              this.savePermissions().then(() => resolve('')).catch(() => reject());
            });
            promiseList.push($permission);
          }
          // saving the roles config
          if (includes(this.security.dirtyCheckList, 'roles')) {
            promiseList.push(new Promise((resolve, reject) => {
              this.securityService.saveRolesConfig().then(() => {
                PropertiesFactory.setRoles(this.security.roles);
                resolve('');
              }).catch(() => reject());
            }));
          }
          //checking for empty authproviders object after 'wms:set-provider-config' event
          if (this.authInfo.authProviders.length === 0) {
            this.authInfo.authProviders.push({
                'enabled': true,
                'type': 'DEMO',
                'users': [{ 'userid': 'user', 'password': 'user', 'roles': ['user'] },
                { 'userid': 'admin', 'password': 'admin', 'roles': ['admin'] }]
            });
          }
        }else{
          this.saveInProgress = false;
        }
        } else {
          promiseList.push(this.securityService.setAuthInfo({
            config: this.authInfo
          }));
        }

        // after saving close the dialog
        Promise.all(promiseList).then(() => {
          this.securityService.hideMessage(true);
          this.securityService.showMessage('', '')
          this.initialSecurityVal = cloneDeep(this.security.enableSecurity);
          this.configSuccess(this.locale.MESSAGE_SUCCESS_SAVE_SECURITY, generalOptions, this.authInfo.enforceSecurity);
          this.securityService.resetForm.next(true);
          this.saveInProgress = false;
          this.security.dirtyCheckList = [];
          this.generateAuthProviders();
          this.fetchProviderOptions();
          if(this.securityTabs[3].subTabs[0].isActive) {
            this.switchSecurityTabs(this.securityTabs[3].subTabs[0],this.securityTabs[3]);
            setTimeout(()=>{
              let avaiableProviderIndex = this.getIndexOfAvailableProvider();
              if(this.authProviders.length > 0 && avaiableProviderIndex !== -1) {
                this.switchToProvider((this.isNewSecurityProvider?this.authProviders[this.authProviders.length - 1]:this.authProviders[avaiableProviderIndex]),this.securityTabs[3].subTabs[0]);
              }
            },500)
          }
          res('');
        }).catch(() => {
          this.saveInProgress = false;
          if (!this.securityProps.message || (this.securityProps.message && !this.securityProps.message.show)) {
            // TODO
            // $timeout(this.showError.bind(undefined, 'MESSAGE_ERROR_OCCURRED'));
            rej();
          }
        });
      }
    });
  };

  validateSecurity(){
    if (this.security.useSSL && !this.security.sslPort) {
      this.securityService.showMessage(this.locale['MESSAGE_ERROR_SSL'], 'error')
      this.securityService.hideMessage(false);
      return false;
    }
    // if sslport is empty and SSL is turned off then assigning the prev port obtained from general call.
    if (!this.security.useSSL && !this.security.sslPort) {
      this.security.sslPort = this.security.prevSSLPort;
    }
    //validate xFrameAlowFromUrl
    if (this.security.xFrameEnabled && this.security.xFrameMode === 'ALLOW_FROM' && !this.security.xFrameAllowFromUrl) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_XFRAME_OPTIONS_ALLOW_FROM_URL'], 'error');
      return false;
    } else if(this.security.xFrameEnabled && this.security.xFrameMode === 'ALLOW_FROM' && !isValidXFrameUrls(this.security.xFrameAllowFromUrl)) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_ERROR_ENTER_VALID_URL'], 'error');
    }
    // Truststore Config
    if(this.security.trustStoreConfig.trustStoreConfigType === 'APPLICATION_ONLY' ||this.security.trustStoreConfig.trustStoreConfigType === 'APPLICATION_AND_SYSTEM'){
      if(!this.security.trustStoreConfig.fileType){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_ERROR_TRUSTSTORE_UPLOAD_FILE_TYPE'], 'error');
      }else if(!this.security.trustStoreConfig.file){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_ERROR_TRUSTSTORE_UPLOAD_FILE'], 'error');
      }else if(!this.security.trustStoreConfig.password){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_ERROR_TRUSTSTORE_PASSWORD'], 'error');
      }
    }
    // Mtls Config
    if(this.security.mtlsConfig.enabled){
      if(!this.security.mtlsConfig.fileType){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_ERROR_MTLS_FILE_TYPE'], 'error');
      }else if(!this.security.mtlsConfig.file){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_ERROR_MTLS_UPLOAD_FILE'], 'error');
      }else if(!this.security.mtlsConfig.password){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_ERROR_MTLS_PASSWORD'], 'error');
      }
    }

    if (this.security.enableSecurity) {
      if (this.isInValidConfig(this.security.login)) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_APP_LOGIN_PAGE_NOT_SET'], 'error');
        return false;
      }else if(this.isInValidConfig(this.security.login.sessionTimeout)){
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_LOGIN_PAGE_NOT_SET'], 'error');
        return false;
      }
    }
    if (!this.security.login.sessionTimeout.timeoutValue) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_SESSION_TIMEOUT_NOT_SET'], 'error');
      return false;
    }
    if(this.security.login.cookieMaxAge === 0){
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_INVALID_COOKIE'], 'error')
    }
    if (this.security.enforceCsrfSecurity) {
      //Validate CSRF header name
      if (this.securityService.hideMsg && !this.security.headerName) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_HEADER_NAME_NOT_SET'], 'error');
        return false;
      }
      //CSRF header name cannot contain special characters
      if (this.securityService.hideMsg && this.security.headerName && (/[@(){}\[\]<>;,:?=\/]/.test(this.security.headerName))) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_INVALID_HEADER_NAME'], 'error');
        return false;
      }
    }

    if (this.security.xssFilterStrategy === WHITE_LIST) {
      //Validate for the policy file if policy file option chosen for white listing strategy
      if (this.security.policyType === POLICY_OPTIONS.IMPORT && !this.security.policyFile) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_POLICY_FILE_NOT_SET'], 'error');
        return false;
      }
      //Save tag rules
      this.updatePolicyConfig();
    }

    if (this.security.corsConfig && this.security.corsConfig.enabled) {
      //validate cors MaxAge value
      if (this.securityService.hideMsg && !this.security.corsConfig.maxAge) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_CORS_MAX_AGE_NOT_SET'], 'error');
        return false;
      }
    }

    if (this.security.login.sessionConcurrencyConfig
      && !isNil(this.security.login.sessionConcurrencyConfig
        && this.security.login.sessionConcurrencyConfig.maxSessionsAllowed)) {
      //value cannot be zero
      if (this.securityService.hideMsg && (this.security.login.sessionConcurrencyConfig.maxSessionsAllowed === 0
        || this.security.login.sessionConcurrencyConfig.maxSessionsAllowed < -1)) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_MAX_SESSIONS_INVALID'], 'error');
        return false;
      }
    }

    if (this.security.sessionPersistenceConfig.enabledType === 'REDIS') {
      //Validate REDIS host
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.REDIS.hostName) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_REDIS_HOST_NOT_SET'], 'error');
        return false;
      }
      //Validate REDIS port
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.REDIS.port) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_REDIS_PORT_NOT_SET'], 'error');
        return false;
      }
      //Add '0' as database by default when no REDIS database is given
      if (!this.security.sessionPersistenceConfig.config.REDIS.database) {
        this.authInfo.sessionPersistenceConfig.config.REDIS.database = '0';
      }
    }

    if (this.security.sessionPersistenceConfig.enabledType === 'MONGODB') {
      //Validate MONGODB host
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.MONGODB.host) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_MONGODB_HOST_NOT_SET'], 'error');
        return false;
      }
      //Validate MONGODB port
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.MONGODB.port) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_MONGODB_PORT_NOT_SET'], 'error');
        return false;
      }
      //Validate MONGODB username
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.MONGODB.username) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_MONGODB_USERNAME_NOT_SET'], 'error');
        return false;
      }
      //Validate MONGODB password
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.MONGODB.password) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_MONGODB_PASSWORD_NOT_SET'], 'error');
        return false;
      }
      //Validate MONGODB dbname
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.MONGODB.dbname) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_MONGODB_DBNAME_NOT_SET'], 'error');
        return false;
      }
    }

    if (this.security.sessionPersistenceConfig.enabledType === 'JDBC') {
      //Validate JDBC database
      if (this.securityService.hideMsg && !this.security.sessionPersistenceConfig.config.JDBC.serviceName) {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(this.locale['MESSAGE_JDBC_SERVICE_NOT_SET'], 'error');
        return false;
      }
    }
    if (!this.securityService.hideMsg) {
      return false;
    }else{
      return true
    }
  }

  //Save tag rules
  updatePolicyConfig() {
    //show error when policy type is import and policy file not chosen other wise make policy API call
    if (this.security.policyType === POLICY_OPTIONS.IMPORT && !this.security.policyFile) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_POLICY_FILE_NOT_SET'], 'error')
    } else {
      this.securityService.setPolicyConfig({
        'config': { 'tagRules': this.getTagRulesModel(), 'unknownTagAction': this.security.tagRules.unknownTag }
      });
    }
  }

  //Merge all the tag rules
  getTagRulesModel() {
    let tagRulesConfig: any = [],
      rules,
      tagRules;
    forEach(this.securityService.ALL_ACTIONS, (action) => {
      rules = this.security.tagRules[action];
      tagRules = map(rules, (tag) => {
        return { 'name': tag, 'action': action };
      });
      tagRulesConfig = concat(tagRulesConfig, tagRules);
    });
    return tagRulesConfig;
  }

  onConfigSet(result: any) {
    return new Promise<void>((res, rej) => {
      if (!result) {
        this.savePermissions().then(() => {
          this.deployProject();
          res();
          this.securityService.hideMessage(true);
        });
        this.saveInProgress = false;
      }
    });
  }

  deployProject() {
    //Set the deployed url to 'null' so that it can be set to the appropriate value after project deploy.
    //call run-project service
    this.projectService.getAppRunURL(false).then(noop).catch(() => this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_DEPLOY_FAILED));
  }

  savePermissions() {
    return new Promise((res, rej) => {
      //create login-logout variables
      let saveVars: any = this.createSecurityVariables();
      this.setRolesAndPermissions().then((saveVariables: any) => {
        //Checking if any of the any of the two functions need saving of variables
        if (saveVars || saveVariables) {
          this.variableService.saveVariables(this.pageWsService.activePageName);
        }
        res('');
      }).catch((errMsg) => {
        this.securityService.hideMessage(false);
        this.securityService.showMessage(errMsg, 'error')
        rej();
      });
    });
  }

  setRolesConfig() {
    return new Promise<void>((res, rej) => {
      // if roles call is already invoked then do not call it again.
      if (!includes(this.security.dirtyCheckList, 'roles')) {
        res();
        return;
      }
      this.securityService.saveRolesConfig().then(() => {
        res();
      }).catch((errMsg) => rej(errMsg));
    });
  }

  //save the roles and permissions in the backend
  setRolesAndPermissions() {
    return new Promise<void>((res, rej) => {
      this.setRolesConfig().then(() => {
        PropertiesFactory.setRoles(this.security.roles);
        this.setPermissions().then((saveVariables?: any) => {
          res(saveVariables)
        }).catch((errMsg) => {
          rej(errMsg);
        })
        res();
      }).catch((errMsg) => rej(errMsg));

    });
  }

  setPermissions() {
    return new Promise((res, rej) => {
      // if permissions call is already invoked then do not call it again.
      if (!includes(this.security.dirtyCheckList, 'permissions')) {
        res('');
        return;
      } else {
        this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('permissions'), 1);
      }
      let request = {
        config: []
      },
        securityURLMap = request.config,
        logoutVariable = this.variableService.getVariableByName(this.LOGOUT_VARIABLE_NAME),
        redirectPage,
        saveVariables = false;

      if (logoutVariable) {
        redirectPage = this.security.login.type === LOGIN_OPTIONS.PAGE ? this.security.login.pageName : this.projectService.getHomePage();
        //assign default value index.html only if show login page is disabled
        if (!logoutVariable.redirectTo) {
          logoutVariable.redirectTo = redirectPage;
          this.variableService.updateVariable(logoutVariable.name, logoutVariable);
          saveVariables = true;
        }
      }

      //set the permissions for the pages
      securityURLMap = this.addPagePermissions(securityURLMap);

      //set the permissions for the prefabs
      securityURLMap = this.addPrefabPermissions(securityURLMap);

      if (this.authorizationService.serviceInterceptUrls.length > 0) {
        this.authorizationService.permissionsChangeArray = this.authorizationService.permissionsChangeArray.concat(this.authorizationService.serviceInterceptUrls);
      }

      //set the permissions for the services and it's operations
      securityURLMap = this.addServicesPermissions(securityURLMap);

      request.config = securityURLMap;
      if (securityURLMap.length) {
        this.securityService.setSecurityInterceptURLs(request).then(() => {
          res(saveVariables);
        }).catch((errMsg) => {
          rej(errMsg);
        });
      } else {
        res(saveVariables);
      }
    });
  }

  //intermediary function to do some minor manipulations before progressing the flow.
  setInterceptPermissionsForServices(serviceObj: any) {
    return this.setInterceptPermissions(serviceObj.permissions.accessLevel);
  }

  addServicesPermissions(securityURLMap: any) {
    let apiDocObj,
      apiDocInterceptObj,
      index;
    /*iterating over the services and creating the object for sending to back-end for saving
     * the permissions*/
    if (this.securityProps.servicesArray && this.securityProps.servicesArray.length !== 0) {
      this.securityProps.servicesArray.forEach((service: any) => {
        //if details for the service is not available, updating it
        if (this.securityProps.servicesUrlMap[service.url] && !this.securityProps.servicesUrlMap[service.url].permissions.url) {
          this.securityProps.servicesUrlMap[service.url].permissions.name = service.name;
          this.securityProps.servicesUrlMap[service.url].permissions.type = this.locale[service.type];
          this.securityProps.servicesUrlMap[service.url].permissions.url = service.url;
        }
        let serviceObj = this.securityProps.servicesUrlMap[service.url],
          serviceInterceptObj: any = serviceObj ? this.setInterceptPermissionsForServices(serviceObj) : {},
          servicesUrlPrefix: any;

        if (serviceObj && (this.authorizationService.permissionsChangeArray.indexOf(serviceObj.permissions.url) > -1)) {
          index = this.isUrlExists(securityURLMap, serviceObj.permissions.url);
          //Updating the existing url map
          if (index > -1) {
            securityURLMap[index].permission = serviceInterceptObj.permission;
            securityURLMap[index].roles = serviceInterceptObj.roles;
          } else {
            //pushing the top level service permissions to the security url map
            securityURLMap.push({
              'urlPattern': serviceObj.permissions.url,
              'permission': serviceInterceptObj.permission,
              'roles': serviceInterceptObj.roles
            });
          }
        }

        //checking if the service has any children services and if it has any operations
        if (service.serviceOperations) {
          //creating a normalized service url
          servicesUrlPrefix = '/services';
          //iterating over api endpoints to get the operations and iterating on operations to create permissions obj for each operation
          forEach(service.serviceOperations.paths, (path) => {
            //iteration over each api document to get the permissions for each api document
            apiDocObj = this.securityProps.servicesUrlMap[servicesUrlPrefix + path[this.authorizationService.BASE_PATH_KEY] + '/**'];
            apiDocInterceptObj = apiDocObj ? this.setInterceptPermissionsForServices(apiDocObj) : {};

            if (apiDocObj && (this.authorizationService.permissionsChangeArray.indexOf(apiDocObj.permissions.url) > -1)) {
              index = this.isUrlExists(securityURLMap, apiDocObj.permissions.url);
              //Updating the existing url map
              if (index > -1) {
                securityURLMap[index].permission = apiDocInterceptObj.permission;
                securityURLMap[index].roles = apiDocInterceptObj.roles;
              } else {
                //pushing the child service permissions to the security url map
                securityURLMap.push({
                  'urlPattern': apiDocObj.permissions.url,
                  'permission': apiDocInterceptObj.permission,
                  'roles': apiDocInterceptObj.roles
                });
              }
            }

            this.authorizationService.supportedOperations.forEach((operation) => {
              var servicePath = servicesUrlPrefix + path[this.authorizationService.BASE_PATH_KEY] + path[this.authorizationService.RELATIVE_PATH_KEY],
                operationObj = this.securityProps.servicesUrlMap[servicePath][operation.toUpperCase()],
                operationInterceptObj,
                opPermIndex;
              // TODO[CODE_QUALITY], check if operationObj check is required.
              if (operationObj) {
                operationInterceptObj = this.setInterceptPermissionsForServices(operationObj);
                opPermIndex = this.authorizationService.permissionsChangeArray.indexOf(operationObj.permissions.url + operation.toUpperCase());
                if (opPermIndex > -1) {
                  index = this.isUrlExists(securityURLMap, operationObj.permissions.url, operation.toUpperCase());
                  //Updating the existing url map
                  if (index > -1) {
                    securityURLMap[index].permission = operationInterceptObj.permission;
                    securityURLMap[index].roles = operationInterceptObj.roles;
                  } else {
                    //pushing the permissions of service operations to the security url map
                    securityURLMap.push({
                      'urlPattern': operationObj.permissions.url,
                      'httpMethod': operationObj.permissions.methodType,
                      'permission': operationInterceptObj.permission,
                      'roles': operationInterceptObj.roles
                    });
                  }
                }
              }
            });
          });
        }
      });
    }

    return securityURLMap;
  }

  //to map the corresponding intercept permission attribute, to send to backend
  setInterceptPermissions(uiAttr: any) {
    let permissionObject = {
      permission: this.authorizationService.PERMISSION_AUTHENTICATED,
      roles: []
    };

    //uiAttr has permissions category - isAuthenticated , return Authenticated
    if (includes(this.authorizationService.defaultPermissions, uiAttr[0]) || !uiAttr[0]) {
      if (this.authorizationService.defaultPermissions[0] === uiAttr[0]) {
        permissionObject.permission = this.authorizationService.PERMISSION_PERMIT_ALL;
      }
      return permissionObject;
    }
    //uiAttr has only one Role, prepend 'hasRole(Role_' string to get the attr
    return {
      permission: 'Role',
      roles: uiAttr || []
    };
  }

  addPagePermissions(securityURLMap: any) {
    let allUrlsMap = this.authorizationService.interceptUrls;
    //sanity check for pages list in permissions tab of UI
    if (this.security.pages) {
      forEach(this.security.pages, (service) => {
        let interceptObj = this.setInterceptPermissions(service.permission);
        //check for service url
        if (service.url) {
          switch (service.type) {
            case 'Partial':
            case 'Page':
            case 'LABEL_FILE_RESOURCE':
            case 'LABEL_APPLICATION':
              if ((service.userChanged || service.url === '/**') && service.permission && this.isUrlExists(securityURLMap, service.url) === -1) {
                securityURLMap.push({
                  'urlPattern': service.url,
                  'permission': interceptObj.permission,
                  'roles': interceptObj.roles
                });
                // removing the visited page url from
                pullAt(allUrlsMap, findIndex(allUrlsMap, { 'urlPattern': service.url }));
              }
              break;
          }
        }
      });
    }

    return securityURLMap;
  }

  //Based on the url pattern checking whether it already exists
  isUrlExists(urlsMap: any, url: any, method?: any) {
    let searchPattern: any = {};
    searchPattern.urlPattern = url;
    //Searching based on the method also
    if (method) {
      searchPattern.httpMethod = method;
    }
    return findIndex(urlsMap, searchPattern);
  }

  addPrefabPermissions(securityURLMap: any) {
    let allUrlsMap = this.authorizationService.interceptUrls;
    //sanity check for pages list in permissions tab of UI
    forEach(this.security.prefabs, (prefab) => {
      let interceptObj = this.setInterceptPermissions(prefab.permission);
      //check for prefab url
      if (prefab.url) {
        if ((prefab.userChanged || prefab.url === '/**') && prefab.permission && this.isUrlExists(securityURLMap, prefab.url) === -1) {
          securityURLMap.push({
            'urlPattern': prefab.url,
            'permission': interceptObj.permission,
            'roles': interceptObj.roles
          });
          //removing the visited page url from
          pullAt(allUrlsMap, findIndex(allUrlsMap, { 'urlPattern': prefab.url }));
        }
      }
    });
    //appending the leftover(prefab) urls to the page urls
    securityURLMap = securityURLMap.concat(allUrlsMap);
    return securityURLMap;
  }

  createSecurityVariables(): any {
    let loginVariable: any,
      logoutVariable: any,
      loggedInUserVariable: any;

    /* if variable already exists, don't create
     * getVariableByName() returns empty object incase of 'no-variable-exists' */
    loginVariable = this.variableService.filterByVariableKeys({ 'owner': VARIABLE_CONSTANTS.OWNER.APP, 'name': this.LOGIN_VARIABLE_NAME });
    if (!loginVariable.length) {
      //create app-level login variable
      loginVariable = this.variableService.createVariable('wm.LoginVariable', { 'owner': VARIABLE_CONSTANTS.OWNER.APP}, this.LOGIN_VARIABLE_NAME );
      loginVariable.category = 'wm.LoginVariable';
      loginVariable.owner = VARIABLE_CONSTANTS.OWNER.APP;
      loginVariable.useDefaultSuccessHandler = true;
      loginVariable.dataBinding = [];

      //Store the variable in collection
      this.variableService.store(VARIABLE_CONSTANTS.OWNER.APP, this.LOGIN_VARIABLE_NAME, loginVariable);
    }

    //if variable already exists, don't create
    if (this.variableService.getVariableByName(this.LOGOUT_VARIABLE_NAME) === null) {
      //create app-level logout variable
      logoutVariable = this.variableService.createVariable('wm.LogoutVariable', { 'owner': VARIABLE_CONSTANTS.OWNER.APP }, this.LOGOUT_VARIABLE_NAME );
      logoutVariable.category = 'wm.LogoutVariable';
      logoutVariable.owner = VARIABLE_CONSTANTS.OWNER.APP;

      //Store the variable in collection
      this.variableService.store(VARIABLE_CONSTANTS.OWNER.APP, this.LOGOUT_VARIABLE_NAME, logoutVariable);
    }

    //if variable already exists, don't create
    if (this.variableService.getVariableByName(this.LOGGED_IN_USER_VARIABLE_NAME) === null) {
      //create app-level logged-in user variable
      loggedInUserVariable = this.variableService.createVariable('wm.Variable', { 'owner': VARIABLE_CONSTANTS.OWNER.APP }, this.LOGGED_IN_USER_VARIABLE_NAME);
      loggedInUserVariable.category = 'wm.Variable';
      loggedInUserVariable.owner = VARIABLE_CONSTANTS.OWNER.APP;
      loggedInUserVariable.dataSet = {
        'name': '',
        'id': '',
        'tenantId': '',
        'isAuthenticated': false,
        'isSecurityEnabled': true,
        'roles': []
      };

      //Store the variable in collection
      this.variableService.store(VARIABLE_CONSTANTS.OWNER.APP, this.LOGGED_IN_USER_VARIABLE_NAME, loggedInUserVariable);
    }

    //if any variable(s) is(are) created, then save it(them)
    if (loginVariable || logoutVariable || loggedInUserVariable) {
      return true;
    }
  }
  //updates the authProviders in authInfo. If the provider is new it will be added to the list otherwise it will get updated with new values.
  setProviderAuthInfo(key: any, value: any) {
    return new Promise((res, rej) => {
      let isNew: boolean = true;
      this.authInfo.enforceSecurity = this.security.enableSecurity;
      for (let index in this.authInfo.authProviders) {
        if (this.authInfo.authProviders[index].type === key) {
          if (value.providerId && this.authInfo.authProviders[index].providerId) {
            if (value.providerId === this.authInfo.authProviders[index].providerId) {
              this.authInfo.authProviders[index] = value;
            }
            else continue;
          }
          else if (value.providerId) {
            continue;
          }
          else {
            this.authInfo.authProviders[index] = value;
          }
          isNew = false;
          break;
        }
      }

      if (isNew) {
        this.authInfo.authProviders.push(value);
      }

      return this.securityService.setAuthInfo({
        config: this.authInfo
      }).then(() => res(''), (errObj) => {
        const err = get(errObj, 'error.errors.error[0]')
        this.securityService.showMessage(replace(err.message.replaceAll('{', '${'), err.parameters) || errObj, 'error')
        rej();
      });
    });
  }

  setDemoProviderConfig() {
    return new Promise((res, rej) => {
      let demoConfig: any = {
        'enabled': this.security.enableSecurityProvider,
        'type': 'DEMO',
        'users': []
      }, userExistsWithNoRoles;

      if (this.authInfo.enforceSecurity) {
        userExistsWithNoRoles = some(this.security.demoUsers, (user) => {
          return user.roles.length === 0;
        });
        if (userExistsWithNoRoles) {
          this.securityService.showMessage(this.locale['MESSAGE_SELECT_ATLEAST_ONE_ROLE'], 'error')
          this.securityService.hideMessage(false);
          rej();
          return;
        }
      }
      forEach(this.security.demoUsers, (user) => {
        demoConfig.users.push({
          'userid': user.username,
          'password': user.password,
          'roles': user.roles
        });
      });
      res(demoConfig);
    });
  }

  //Validating the db configuration if the mandatory fields are provided
  validateDBConfig(isRoleProvider?: any) {
    if (!this.security.modelName || this.security.modelName === '') {
      this.securityService.showMessage(this.locale['MESSAGE_DATAMODEL_NOT_SET'], 'error')
      this.securityService.hideMessage(false);
    } else if ((this.security.provider.value === 'Database' || this.security.roleConfig === 'BASIC') && (!this.security.tableName || this.security.tableName === '')) {
      this.securityService.showMessage(this.locale['MESSAGE_USER_TABLE_NOT_SET'], 'error')
      this.securityService.hideMessage(false);
    } else if (!isRoleProvider && (!this.security.uidPropertyName || this.security.uidPropertyName === '')) {
      this.securityService.showMessage(this.locale['MESSAGE_USERID_NOT_SET'], 'error')
      this.securityService.hideMessage(false);
    } else if ((this.security.provider.value === 'Database' || this.security.roleConfig === 'BASIC') && (!this.security.unamePropertyName || this.security.unamePropertyName === '')) {
      this.securityService.showMessage(this.locale['MESSAGE_USERNAME_NOT_SET'], 'error')
      this.securityService.hideMessage(false);
    } else if (!isRoleProvider && (!this.security.pwPropertyName || this.security.pwPropertyName === '')) {
      this.securityService.showMessage(this.locale['MESSAGE_PASSWORD_NOT_SET'], 'error')
      this.securityService.hideMessage(false);
    } else if (this.security.useRolesQuery) {
      if (!this.securityService.editorContent) {
        this.securityService.showMessage(this.locale['MESSAGE_ROLE_QUERY_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.isRolesQueryTested) {
        //Makes sure that if the query is modified, it is tested
        this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
        this.securityService.hideMessage(false);
      }
    }
  }

  setDatabaseProviderConfig() {
    return new Promise((res, rej) => {
      let dbConfig;

      this.validateDBConfig();

      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      dbConfig = {
        'modelName': this.security.modelName,
        'entityName': this.securityProps.tableEntityMap[this.security.tableName],
        'tableName': this.security.tableName,
        'unamePropertyName': this.securityProps.columnFieldMap[this.security.unamePropertyName],
        'unameColumnName': this.security.unamePropertyName,
        'uidPropertyName': this.securityProps.columnFieldMap[this.security.uidPropertyName],
        'uidColumnName': this.security.uidPropertyName,
        'pwPropertyName': this.securityProps.columnFieldMap[this.security.pwPropertyName],
        'pwColumnName': this.security.pwPropertyName,
        'rolePropertyName': this.security.useRolesQuery ? '' : this.securityProps.columnFieldMap[this.security.rolePropertyName] || '',
        'roleColumnName': this.security.useRolesQuery ? '' : (this.security.rolePropertyName || ''),
        'useRolesQuery': this.security.useRolesQuery,
        'rolesByUsernameQuery': this.security.useRolesQuery ? this.securityService.editorContent : '',
        'tenantIdField': this.security.tenantIdField,
        'defTenantId': this.security.defTenantId,
        'queryType': this.security.queryType,
        'enabled': this.security.enableSecurityProvider,
        'type': 'DATABASE'

      };
      res(dbConfig);
    });
  }

  setProviderConfig(provider: string): any {
    switch (provider) {
      case 'Demo':
        return this.setDemoProviderConfig();
      case 'Database':
        return this.setDatabaseProviderConfig();
      case 'LDAP':
        return this.setLDAPProviderConfig();
      case 'AD':
        return this.setADProviderConfig();
      case 'CAS':
        return this.setCASProviderConfig();
      case 'Custom':
        return this.setCustomProviderConfig();
      case 'OpenId':
        return this.setOpenIdProviderConfig();
      case 'SAML':
        return this.setSAMLProviderConfig();
      case 'JWS':
        return this.setJWSProviderConfig();
      case 'OPAQUE_TOKEN':
        return this.setOPAQUEProviderConfig();
    }
  }

  setSAMLProviderConfig() {
    return new Promise((res, rej) => {
      let samlConfig: any;

      if (!this.security.idpMetadataUrl && (this.security.idpMetadataSource === this.security.metadataSrcOptionsMap.URL)) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_IDP_METADATA_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!isValidWebURL(this.security.idpMetadataUrl) && (this.security.idpMetadataSource === this.security.metadataSrcOptionsMap.URL)) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_IDP_METADATA_INVALID'], 'error')
        this.securityService.hideMessage(false);
      } else if (this.securityService.isUrlDirty || !this.security.idpPublicKey) {
        if (this.security.idpMetadataSource === this.security.metadataSrcOptionsMap.URL) {
          this.securityService.showMessage(this.locale['MESSAGE_SAML_LOAD_BEFORE_SAVE'], 'error')
          this.securityService.hideMessage(false);
        } else {
          this.securityService.showMessage(this.locale['MESSAGE_SAML_UPLOAD_METADATA_FILE'], 'error')
          this.securityService.hideMessage(false);
        }
      } else if (!this.security.metadataFileName && (this.security.idpMetadataSource === this.security.metadataSrcOptionsMap.FILE)) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_UPLOAD_METADATA_FILE'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.keyStoreName && this.security.keyStoreValue === this.security.keyStoreOptions[1]) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_JSK_FILE_NOT_UPLOAD'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.keyAlias) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_ALIAS_KEY_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.keyStorePassword) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_PASSWORD_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (this.security.keyStorePassword.length < 6) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_PASSWORD_LENGTH'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.subjectName && this.security.keyStoreValue === this.security.keyStoreOptions[0]) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_SUBJECT_NAME_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (this.security.maxAuthenticationAge <= 0) {
        this.securityService.showMessage(this.locale['MESSAGE_SAML_MAX_AUTH_AGE_LESS_THAN_ZERO'], 'error')
        this.securityService.hideMessage(false);
      }

      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      //check for role provider
      if (this.security.roleMappingEnabled && !this.security.roleProvider) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //if use roles query is true and query is not tested, prompt error message
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            rej();
            return;
          }
          this.validateDBConfig(true);
        } else if (!this.security.roleAttributeName) {
          this.securityService.showMessage(this.locale['MESSAGE_ROLE_ATTRIBUTE_NAME_NOT_SET'], 'error')
          this.securityService.hideMessage(false);
          rej();
          return;
        }
      }
        //on error
        if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
          rej();
          return;
        }

      samlConfig = {
        idpMetadataUrl: this.security.idpMetadataUrl,
        idpMetadataSource: this.security.idpMetadataSource,
        idpPublicKey: this.security.idpPublicKey,
        createKeystore: this.getCreateKeystoreValue(),
        idpEndpointUrl: this.security.idpEndpointUrl,
        keyStoreLocation: this.security.keyStoreLocation || JKS_FILE_PATH,
        keyStoreName: this.security.keyStoreName || KEY_STORE_NAME,
        keyStorePassword: this.security.keyStorePassword,
        keyAlias: this.security.keyAlias,
        subjectName: this.security.subjectName,
        maxAuthenticationAge: this.security.maxAuthenticationAge,
        roleMappingEnabled: this.security.roleMappingEnabled,
        roleMappingConfig: null,
        attributes: this.security.attributes,
        enabled: this.security.enableSecurityProvider,
        type: 'SAML'
      };

      if (this.security.roleMappingEnabled) {
        samlConfig.roleMappingConfig = {};
        if (this.security.roleProvider === 'Database') {
          samlConfig.roleMappingConfig = {
            modelName: this.security.modelName,
            entityName: this.securityProps.tableEntityMap[this.security.tableName],
            tableName: this.security.tableName,
            usernameField: this.securityProps.columnFieldMap[this.security.unamePropertyName],
            usernameColumn: this.security.unamePropertyName,
            roleField: this.securityProps.columnFieldMap[this.security.rolePropertyName],
            roleColumn: this.security.rolePropertyName,
            useRolesQuery: this.security.useRolesQuery,
            roleQuery: this.security.useRolesQuery ? this.securityService.editorContent : '',
            queryType: this.security.queryType,
            type : SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          samlConfig.roleMappingConfig = {
            roleAttributeName: this.security.roleAttributeName,
            type : SecurityComponent.ROLE_MAPPING_ATTR_NAME
          };
        }
      }
      res(samlConfig);
    });
  }

  getCreateKeystoreValue() {
    if (this.security.createKeystore === null || this.security.createKeystore === undefined) {
      //return true if keyStore is autogenerate else return false.
      return this.security.keyStoreValue === this.security.keyStoreOptions[0];
    }
    return this.security.createKeystore;
  }

  setOpenIdProviderConfig() {
    return new Promise((res, rej) => {
      let openIdProviderConfig: any,
        errorMsg,
        scopes,
        provider,
        errorLocale;
      const providerIdRegEx = /^(?!\d)(?=.*[a-zA-Z])[a-zA-Z0-9_]+$/;  // RegEx to match string with lowercase & uppercase & _ letters & digits.
      // validations for the properties.

      if (!this.security.providerId) {
        errorLocale = this.localeMap.providerId;
      }
      else if(this.isNewSecurityProvider && !providerIdRegEx.test(this.security.providerId)){
         errorLocale = this.localeMap.incorrectProviderId;
      }
      else if (!this.security.authorizationUrl) {
        errorLocale = this.localeMap.authorizationUrl;
      }else if (!this.security.tokenUrl) {
        errorLocale = this.localeMap.tokenUrl;
      }else if (!this.security.jwkSetUrl) {
        errorLocale = this.localeMap.jwkSetUrl;
      }else if (!this.security.userInfoUrl) {
        errorLocale = this.localeMap.userInfoUrl;
      }else if (!this.security.clientId) {
        errorLocale = this.localeMap.clientId;
      }else if (!this.security.clientSecret) {
        errorLocale = this.localeMap.clientSecret;
      }

      if (errorLocale) {
        errorMsg = replace(this.locale.MESSAGE_PROVIDE_VALUE, [this.locale[errorLocale]]);
        this.securityService.showMessage(errorMsg, 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //check for role provider
      if (this.security.roleMappingEnabled && !this.security.roleProvider) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        return;
      }

      //if use roles query is true and query is not tested, prompt error message
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === DB_PROVIDER.id) {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            return;
          }
          this.validateDBConfig(true);
        } else if (!this.security.roleAttributeName) {
          this.securityService.showMessage(this.locale['MESSAGE_ROLE_ATTRIBUTE_NAME_NOT_SET'], 'error')
          this.securityService.hideMessage(false);
          return;
        }
      }
      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        return;
      }

      this.security.scopes = this.security.scopes || '';

      // scopes are saved as array of strings.
      scopes = map(this.security.scopes.split(','), trim);
      provider = {
        providerId: this.security.providerId,
        clientId: this.security.clientId,
        clientSecret: this.security.clientSecret,
        authorizationUrl: this.security.authorizationUrl,
        tokenUrl: this.security.tokenUrl,
        jwkSetUrl: this.security.jwkSetUrl,
        userInfoUrl: this.security.userInfoUrl,
        logoutUrl: this.security.logoutUrl,
        scopes: scopes,
        userNameAttributeName: this.security.userNameAttributeName,
        redirectUrlTemplate: this.security.redirectUrlTemplate
      };

      openIdProviderConfig = {
        ...provider,
        roleMappingEnabled: this.security.roleMappingEnabled,
        enabled: this.security.enableSecurityProvider,
        type: 'OPENID'
      };

      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === DB_PROVIDER.id) {
          openIdProviderConfig.roleMappingConfig = {
            modelName: this.security.modelName,
            entityName: this.securityProps.tableEntityMap[this.security.tableName],
            tableName: this.security.tableName,
            usernameField: this.securityProps.columnFieldMap[this.security.unamePropertyName],
            usernameColumn: this.security.unamePropertyName,
            roleField: this.securityProps.columnFieldMap[this.security.rolePropertyName],
            roleColumn: this.security.rolePropertyName,
            useRolesQuery: this.security.useRolesQuery,
            roleQuery: this.security.useRolesQuery ? this.securityService.editorContent : '',
            queryType: this.security.queryType,
            type: SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          openIdProviderConfig.roleMappingConfig = {
            roleAttributeName: this.security.roleAttributeName || null,
            type: SecurityComponent.ROLE_MAPPING_ATTR_NAME
          };
        }
      }
      res(openIdProviderConfig);
    });
  }

  setCustomProviderConfig() {
    return new Promise((res, rej) => {
      let customSecurityConfig;

      if (!this.security.custom.authClassName || this.security.custom.authClassName === '') {
        this.securityService.showMessage(this.locale['MESSAGE_CLASS_NAME_MISSING'], 'error')
        this.securityService.hideMessage(false);
      }
      if (!isValidJavaPackageName(this.security.custom.authClassName)) {
        this.securityService.showMessage(this.locale['MESSAGE_CLASS_NAME_INVALID'], 'error')
        this.securityService.hideMessage(false);
      }
      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      customSecurityConfig = {
        'fqCustomAuthenticationManagerClassName': this.security.custom.authClassName,
        'enabled': this.security.enableSecurityProvider,
        'type': 'CUSTOM'
      };
      res(customSecurityConfig);
    });
  }

  setCASProviderConfig() {
    return new Promise((res, rej) => {
      let casConfig: any;

      if (!this.security.serverUrl || this.security.serverUrl === '') {
        this.securityService.showMessage(this.locale['MESSAGE_CAS_URL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.loginUrl || this.security.loginUrl === '') {
        this.securityService.showMessage(this.locale['MESSAGE_CAS_LOGIN_URL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.logoutUrl || this.security.logoutUrl === '') {
        this.securityService.showMessage(this.locale['MESSAGE_CAS_LOGOUT_URL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.validationUrl || this.security.validationUrl === '') {
        this.securityService.showMessage(this.locale['MESSAGE_CAS_VALIDATION_URL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.serviceParameter) {
        this.securityService.showMessage(this.locale['MESSAGE_CAS_SERVICE_PARAMETER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.artifactParameter) {
        this.securityService.showMessage(this.locale['MESSAGE_CAS_TICKET_PARAMETER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      }

      //check for role provider
      if (this.security.roleMappingEnabled && !this.security.roleProvider) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //if use roles query is true and query is not tested, prompt error message
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            return;
          }
          this.validateDBConfig(true);
        } else if (!this.security.roleAttributeName) {
          this.securityService.showMessage(this.locale['MESSAGE_CAS_ROLE_ATTRIBUTE_NAME_NOT_SET'], 'error')
          this.securityService.hideMessage(false);
        }
      }
      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      casConfig = {
        'serverUrl': this.security.serverUrl,
        'loginUrl': this.security.loginUrl,
        'logoutUrl': this.security.logoutUrl,
        'validationUrl': this.security.validationUrl,
        'artifactParameter': this.security.artifactParameter,
        'serviceParameter': this.security.serviceParameter,
        'roleMappingEnabled': this.security.roleMappingEnabled,
        'roleMappingConfig': null,
        'attributes': this.security.attributes,
        'enabled': this.security.enableSecurityProvider,
        'type': 'CAS'

      };

      if (this.security.roleMappingEnabled) {
        casConfig.roleMappingConfig = {};
        if (this.security.roleProvider === 'Database') {
          casConfig.roleMappingConfig = {
            'modelName': this.security.modelName,
            'entityName': this.securityProps.tableEntityMap[this.security.tableName],
            'tableName': this.security.tableName,
            'usernameField': this.securityProps.columnFieldMap[this.security.unamePropertyName],
            'usernameColumn': this.security.unamePropertyName,
            'roleField': this.securityProps.columnFieldMap[this.security.rolePropertyName],
            'roleColumn': this.security.rolePropertyName,
            'useRolesQuery': this.security.useRolesQuery,
            'roleQuery': this.security.useRolesQuery ? this.securityService.editorContent : '',
            'queryType': this.security.queryType,
            'type': SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          casConfig.roleMappingConfig = {
            'roleAttributeName': this.security.roleAttributeName || null,
            'type': SecurityComponent.ROLE_MAPPING_ATTR_NAME
          };
        }
      }
      res(casConfig);
    });
  }

  setJWSProviderConfig() {
    return new Promise((res, rej) => {
      let jwsConfig: any;

      if (!this.security.providerId || this.security.providerId === '') {
        this.securityService.showMessage(this.locale['MESSAGE_JWS_PROVIDERID_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.issuerUrl || this.security.issuerUrl === '') {
        this.securityService.showMessage(this.locale['MESSAGE_JWS_ISSUERURL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.principalClaimName || this.security.principalClaimName === '') {
        this.securityService.showMessage(this.locale['MESSAGE_JWS_PRINCIPALCLAIMNAME_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      }

      //check for role provider
      if (this.security.roleMappingEnabled && !this.security.roleProvider) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //if use roles query is true and query is not tested, prompt error message
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            return;
          }
          this.validateDBConfig(true);
        } else if (!this.security.roleAttributeName) {
          this.securityService.showMessage(this.locale['MESSAGE_CAS_ROLE_ATTRIBUTE_NAME_NOT_SET'], 'error')
          this.securityService.hideMessage(false);
        }
      }
      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      jwsConfig = {
        'providerId': this.security.providerId,
        'issuerUrl': this.security.issuerUrl,
        'principalClaimName': this.security.principalClaimName,
        'roleMappingEnabled': this.security.roleMappingEnabled,
        'roleMappingConfig': null,
        'enabled': this.security.enableSecurityProvider,
        'type': 'JWS'

      };

      if (this.security.roleMappingEnabled) {
        jwsConfig.roleMappingConfig = {};
        if (this.security.roleProvider === 'Database') {
          jwsConfig.roleMappingConfig = {
            'modelName': this.security.modelName,
            'entityName': this.securityProps.tableEntityMap[this.security.tableName],
            'tableName': this.security.tableName,
            'usernameField': this.securityProps.columnFieldMap[this.security.unamePropertyName],
            'usernameColumn': this.security.unamePropertyName,
            'roleField': this.securityProps.columnFieldMap[this.security.rolePropertyName],
            'roleColumn': this.security.rolePropertyName,
            'useRolesQuery': this.security.useRolesQuery,
            'roleQuery': this.security.useRolesQuery ? this.securityService.editorContent : '',
            'queryType': this.security.queryType,
            'type': SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          jwsConfig.roleMappingConfig = {
            'roleAttributeName': this.security.roleAttributeName || null,
            'type': SecurityComponent.ROLE_MAPPING_ATTR_NAME
          };
        }
      }
      res(jwsConfig);
    });
  }



  setOPAQUEProviderConfig() {
    return new Promise((res, rej) => {
      let opaqueConfig: any;

      if (!this.security.introspectionUrl || this.security.introspectionUrl === '') {
        this.securityService.showMessage(this.locale['MESSAGE_OPAQUE_INTROSPECTIONURL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.clientId || this.security.clientId === '') {
        this.securityService.showMessage(this.locale['MESSAGE_OPAQUE_CLIENTID_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.clientSecret || this.security.clientSecret === '') {
        this.securityService.showMessage(this.locale['MESSAGE_OPAQUE_CLIENTSECRET_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      } else if (!this.security.principalClaimName || this.security.principalClaimName === '') {
        this.securityService.showMessage(this.locale['MESSAGE_OPAQUE_PRINCIPALCLAIMNAME_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
      }

      //check for role provider
      if (this.security.roleMappingEnabled && !this.security.roleProvider) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //if use roles query is true and query is not tested, prompt error message
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            return;
          }
          this.validateDBConfig(true);
        } else if (!this.security.roleAttributeName) {
          this.securityService.showMessage(this.locale['MESSAGE_CAS_ROLE_ATTRIBUTE_NAME_NOT_SET'], 'error')
          this.securityService.hideMessage(false);
        }
      }
      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      opaqueConfig = {
        'introspectionUrl': this.security.introspectionUrl,
        'clientId': this.security.clientId,
        'clientSecret': this.security.clientSecret,
        'principalClaimName': this.security.principalClaimName,
        'roleMappingEnabled': this.security.roleMappingEnabled,
        'roleMappingConfig': null,
        'enabled': this.security.enableSecurityProvider,
        'type': 'OPAQUE_TOKEN'

      };

      if (this.security.roleMappingEnabled) {
        opaqueConfig.roleMappingConfig = {};
        if (this.security.roleProvider === 'Database') {
          opaqueConfig.roleMappingConfig = {
            'modelName': this.security.modelName,
            'entityName': this.securityProps.tableEntityMap[this.security.tableName],
            'tableName': this.security.tableName,
            'usernameField': this.securityProps.columnFieldMap[this.security.unamePropertyName],
            'usernameColumn': this.security.unamePropertyName,
            'roleField': this.securityProps.columnFieldMap[this.security.rolePropertyName],
            'roleColumn': this.security.rolePropertyName,
            'useRolesQuery': this.security.useRolesQuery,
            'roleQuery': this.security.useRolesQuery ? this.securityService.editorContent : '',
            'queryType': this.security.queryType,
            'type': SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          opaqueConfig.roleMappingConfig = {
            'roleAttributeName': this.security.roleAttributeName || null,
            'type': SecurityComponent.ROLE_MAPPING_ATTR_NAME
          };
        }
      }
      res(opaqueConfig);
    });
  }






  setADProviderConfig() {
    return new Promise((res, rej) => {
      let
        adConfig: any;

      //check for url
      if (!this.security.url || this.security.url === '') {
        this.securityService.showMessage(this.locale['MESSAGE_URL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      if (!this.security.rootDn || this.security.rootDn === '') {
        this.securityService.showMessage(this.locale['MESSAGE_ROOT_DN_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //checking if connection has been tested only if configuration details has been changed, if not prompting error message
      if (this.security.enableSecurity && (!this.security.isConncetionTested && this.securityService.configurationDetailsChanged)) {
        this.securityService.showMessage(this.locale['MESSAGE_CONNECTION_NOT_TESTED'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //check for role provider
      if (this.security.roleMappingEnabled) {
        if (!this.security.roleProvider) {
          this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
          this.securityService.hideMessage(false);
          rej();
          return;
        }
        //if use roles query is true and query is not tested, prompt error message
        if (this.security.roleProvider === 'Database') {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            rej();
            return;
          }
          this.validateDBConfig(true);
        }
      }

      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      adConfig = {
        'domain': this.security.domain,
        'url': this.security.url,
        'managerDn': this.security.managerDn,
        'managerPassword': this.security.managerPassword,
        'roleMappingEnabled': this.security.roleMappingEnabled,
        'roleProvider': this.security.roleMappingEnabled ? this.security.roleProvider : undefined,
        'rootDn': this.security.rootDn,
        'userSearchPattern': this.security.userSearchPattern,
        'roleMappingConfig': null,
        'enabled': this.security.enableSecurityProvider,
        'type': 'AD'
      };

      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          adConfig.roleMappingConfig = {
            'modelName': this.security.modelName,
            'entityName': this.securityProps.tableEntityMap[this.security.tableName],
            'tableName': this.security.tableName,
            'usernameField': this.securityProps.columnFieldMap[this.security.unamePropertyName],
            'usernameColumn': this.security.unamePropertyName,
            'roleField': this.securityProps.columnFieldMap[this.security.rolePropertyName],
            'roleColumn': this.security.rolePropertyName,
            'useRolesQuery': this.security.useRolesQuery,
            'roleQuery': this.security.useRolesQuery ? this.securityService.editorContent : '',
            'queryType': this.security.queryType,
            'type': SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          adConfig.roleMappingConfig = {
            'groupRoleAttribute': this.security.roleMappingEnabled ? this.security.adGroupRoleAttribute : null,
            'type': SecurityComponent.ROLE_MAPPING_AD,
          };
        }
      }
      res(adConfig);
    });
  }

  setLDAPProviderConfig() {
    return new Promise((res, rej) => {
      let ldapConfig: any;

      //check for url
      if (!this.security.url || this.security.url === '') {
        this.securityService.showMessage(this.locale['MESSAGE_LDAP_URL_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      if (!this.security.userDnPattern) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_SEARCH_PATTERN_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //checking if connection has been tested only if configuration details has been changed, if not prompting error message
      if (this.security.enableSecurity && (!this.security.isConncetionTested && this.securityService.configurationDetailsChanged)) {
        this.securityService.showMessage(this.locale['MESSAGE_CONNECTION_NOT_TESTED'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //check for role provider
      if (this.security.roleMappingEnabled && !this.security.roleProvider) {
        this.securityService.showMessage(this.locale['MESSAGE_USER_ROLE_PROVIDER_NOT_SET'], 'error')
        this.securityService.hideMessage(false);
        rej();
        return;
      }

      //if use roles query is true and query is not tested, prompt error message
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          if (this.security.useRolesQuery && !this.security.isRolesQueryTested) {
            this.securityService.showMessage(this.locale['MESSAGE_ROLES_QUERY_NOT_TESTED'], 'error')
            this.securityService.hideMessage(false);
            rej();
            return;
          }
          this.validateDBConfig(true);
        } else {
          if (!this.security.groupSearchBase) {
            this.securityService.showMessage(this.locale['MESSAGE_GROUP_SEARCH_BASE_NOT_SET'], 'error')
            this.securityService.hideMessage(false);
          } else if (!this.security.ldapGroupRoleAttribute) {
            this.securityService.showMessage(this.locale['MESSAGE_GROUP_ROLE_ATTRIBUTE_NOT_SET'], 'error')
            this.securityService.hideMessage(false);
          } else if (!this.security.groupSearchFilter) {
            this.securityService.showMessage(this.locale['MESSAGE_GROUP_SEARCH_FILTER_NOT_SET'], 'error')
            this.securityService.hideMessage(false);
          }
        }
      }
      //on error
      if (!this.securityService.hideMsg && this.securityService.messageService.type === 'error') {
        rej();
        return;
      }

      ldapConfig = {
        'domain': 'wavemaker.com',
        'url': this.security.url,
        'userDnPattern': this.security.userDnPattern,
        'managerDn': this.security.managerDn,
        'managerPassword': this.security.managerPassword,
        'groupSearchBase': this.security.roleMappingEnabled ? this.security.groupSearchBase : null,
        'roleMappingEnabled': this.security.roleMappingEnabled,
        'roleProvider': this.security.roleMappingEnabled ? this.security.roleProvider : null,
        'roleMappingConfig': null,
        'enabled': this.security.enableSecurityProvider,
        'type': 'LDAP'

      };
      if (this.security.roleMappingEnabled) {
        if (this.security.roleProvider === 'Database') {
          ldapConfig.roleMappingConfig = {
            'modelName': this.security.modelName,
            'entityName': this.securityProps.tableEntityMap[this.security.tableName],
            'tableName': this.security.tableName,
            'usernameField': this.securityProps.columnFieldMap[this.security.unamePropertyName],
            'usernameColumn': this.security.unamePropertyName,
            'roleField': this.securityProps.columnFieldMap[this.security.rolePropertyName],
            'roleColumn': this.security.rolePropertyName,
            'useRolesQuery': this.security.useRolesQuery,
            'roleQuery': this.security.useRolesQuery ? this.securityService.editorContent : '',
            'queryType': this.security.queryType,
            'type': SecurityComponent.ROLE_MAPPING_DATABASE
          };
        } else {
          ldapConfig.roleMappingConfig = {
            'groupRoleAttribute': this.security.roleMappingEnabled ? this.security.ldapGroupRoleAttribute : null,
            'groupSearchFilter': this.security.roleMappingEnabled ? this.security.groupSearchFilter : null,
            'type': SecurityComponent.ROLE_MAPPING_LDAP
          };
        }
      }
      res(ldapConfig);
    });
  }

  //Success handler for security configuration service
  configSuccess(message: any, options: any, enforceSecurity: any) {
    //For caching purpose sending the current general options only if save is successful
    this.securityService.cacheGeneralOptions(options);
    this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, message);
  }

  discardChanges() {
    this.securityService.resetForm.next(false);
    this.security.dirtyCheckList = [];
    this.security.enableSecurity = this.initialSecurityVal;
    if(!this.security.enableSecurity){
      this.securityService.showMessage(this.locale.MESSAGE_ENABLE_SECURITY, 'warning')
    }else{
      this.securityService.hideMessage(true)
    }
    if(this.securityTabs[3].subTabs[0].isActive) {
      let availableProviderIdx: number = this.getIndexOfAvailableProvider();
      if (availableProviderIdx !== -1) {
        this.switchToProvider(this.authProviders[availableProviderIdx], this.securityTabs[3].subTabs[0]);
      } else {
        this.isNewSecurityProvider = false;
        this.addNewSecurityProvider();
      }
    }
  };

  isWSDirty() {
    return this.security?.dirtyCheckList?.length > 0;
  };
  confirmDelete(index: number) {
    this.deleteSecurityProvider(index);
    this.close('deleteDialog')
  }
  open(id: string,index: number) {
    if(this.authProviders.length === 1) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_MINIMUM_SECURITY_PROVIDER'], 'error');
    } else if(this.authInfo.authProviders[index].enabled && this.securityService.getEnabledProvidersCount(this.authInfo) === 1) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale['MESSAGE_MINIMUM_ENABLED_PROVIDERS_TO_DELETE'], 'error');
    }
    else {
      this.dialogContent = 'Are you sure to delete ' + this.getProviderName(this.authProviders[index].id);
      this.deleteProviderIndex = index;
      this.dialogService.open(id);
    }
  }
  close(id: string) {
    this.dialogService.close(id);
  }
  getIndexOfAvailableProvider() : number {
    for(let index in this.authProviders) {
      if(startsWith(this.authProviders[index].id,"OPENID") || includes(this.authProviders[index].id,"JWS") ||
                                           find(this.security.providerOptions, { id: this.authProviders[index].id })) {
        return parseInt(index);
      }
    }
    return -1;
  }
  isAllowedToDisableSecurityProvider() {
    let enabledCnt: number = this.securityService.getEnabledProvidersCount(this.authInfo);
    let activeProviderIndex: number = this.getActiveProviderIndex();
    let isAllowedToDisable: boolean = this.isProvidersDisabled ? (activeProviderIndex >= 0
                                        && activeProviderIndex < this.authInfo.authProviders.length &&
                                          this.authInfo.authProviders[activeProviderIndex].enabled ?
                                              enabledCnt > 1 : enabledCnt >= 1) : enabledCnt >= 1;
    return isAllowedToDisable;
  }
  getActiveProviderIndex() {
    return findIndex(this.authProviders, { isActive: true });
  }
}
